import { LumoraClient, LUMORA_PROD_API_BASE_URL, localStorageTokens } from "@lumora/bridge";

export const SITE = import.meta.env.VITE_LUMORA_SITE ?? "lumora";

const STORAGE_KEY = "lumora.portal.tokens";

/** Stripe publishable key for the Payment Element (undefined in keyless builds). */
export const STRIPE_PUBLISHABLE_KEY = import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY;

export const client = new LumoraClient({
  baseUrl: import.meta.env.VITE_LUMORA_API ?? LUMORA_PROD_API_BASE_URL,
  ...localStorageTokens(STORAGE_KEY),
});

/** Owner sign-out (#457): drops portal tokens. Remembered site slug kept for display. */
export function signOutOwner(): void {
  client.logout();
}
